import React from "react";
import AppRoutes from "./pages/routes/AppRoutes";
import "./App.css";
import ScrollToTop from "./ScrollToTop";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
    </>
  );
}
